// extracted by mini-css-extract-plugin
module.exports = {"visible":"visible__Ym8GA","bff-show":"bff-show__QVo+H"};